/* src/app/questionnaire/popover/popover.component.scss */
.infoText {
  font-family:
    Arial,
    Helvetica,
    sans-serif;
  font-size: 4.5vw;
  margin: 0;
  padding: 0.4em;
}
@media (min-width: 600px) {
  .infoText {
    font-size: 24px;
  }
}
/*# sourceMappingURL=popover.component.css.map */
